import { Clock, Sparkles, Award } from "lucide-react";

const BADGES = {
  coming_soon: { label: "Coming Soon", Icon: Clock, cls: "bg-sky-500 text-white" },
  premiering: { label: "Premiering", Icon: Sparkles, cls: "bg-terracotta text-white" },
  festival_run: { label: "Festival Run", Icon: Award, cls: "bg-gold text-ink" },
};

// State badge for non-public publishing states; Public films get none.
export function PublishingBadge({ film }) {
  const b = BADGES[film?.publishing_state];
  if (!b) return null;
  const { label, Icon, cls } = b;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider shadow-md shadow-black/40 ${cls}`}
      data-testid={`publishing-badge-${film.publishing_state}-${film.id}`}
    >
      <Icon className="w-3 h-3" /> {label}
    </span>
  );
}
